import { useContext } from 'react';
import { type VideoSyncFunctions, VideoSyncFunctionsContext } from './CompareViewContext';

export function useSyncPlay(): VideoSyncFunctions | null {
  return useContext(VideoSyncFunctionsContext);
}
